import { useState } from "react";
import { useLocation, useNavigate } from 'react-router-dom';

import { useProjects } from "../services/api/KeynomeAPIHooks";
import { datadogRum } from '@datadog/browser-rum';
import { useOutletContext } from "react-router-dom";
import { Dialog, DialogTitle, DialogContent, DialogContentText, DialogActions, Button, Select, MenuItem, FormControl, InputLabel } from "@mui/material";

import { useMoveDatasetToProject } from "../services/api/KeynomeAPIMutations";

function MoveDatasetDialog(props) {
    const {
        activeProject,
        activeRun,
        moveDatasetDialogOpen,
        setMoveDatasetDialogOpen,
    } = props;

    const { setUserErrorMessage } = useOutletContext();
    const [selectedProject, setSelectedProject] = useState('');
    const navigate = useNavigate();
    const location = useLocation();

    const { data: projects } = useProjects(activeProject.attributes.organization_id);
    const { mutateAsync: moveDataset, isPending } = useMoveDatasetToProject();

    const availableProjects = (projects || []).filter(
        ({ id, attributes }) => id !== activeProject.id && attributes.name !== "archive"
    );

    const handleMoveConfirm = async () => {
        try {
            const movedDataset = await moveDataset({
                datasetId: activeRun.id,
                destProjectId: selectedProject.id
            });

            setMoveDatasetDialogOpen(false);
            navigate(
                `/projects/${selectedProject.attributes.uuid}/runs/${movedDataset.attributes.uuid}`,
                { state: location.state }
            );
        } catch (error) {
            setUserErrorMessage('Failed to move dataset! Please wait a few minutes and try again. Contact support@dayzerodiagnostics.com if you require assistance.');
            datadogRum.addError(error);
        }
    };

    return <Dialog
        open={moveDatasetDialogOpen}
        onClose={() => setMoveDatasetDialogOpen(false)}
    >
        <DialogTitle>Move Dataset</DialogTitle>
        <DialogContent>
            <DialogContentText sx={{ mb: 2 }}>
                Select a project to move this dataset to:
            </DialogContentText>
            <FormControl fullWidth>
                <InputLabel>Destination Project</InputLabel>
                <Select
                    value={selectedProject}
                    onChange={(e) => setSelectedProject(e.target.value)}
                    label="Destination Project"
                >
                    {availableProjects.map(project => (
                        <MenuItem key={project.id} value={project}>
                            {project.attributes.name}
                        </MenuItem>
                    ))}
                </Select>
            </FormControl>
        </DialogContent>
        <DialogActions>
            <Button onClick={() => setMoveDatasetDialogOpen(false)} disabled={isPending}>
                Cancel
            </Button>
            <Button 
                onClick={handleMoveConfirm}
                color="primary"
                variant="contained"
                autoFocus
                disabled={isPending || !selectedProject}
            >
                {isPending ? 'Moving...' : 'Move Dataset'}
            </Button>
        </DialogActions>
    </Dialog>
}

export default MoveDatasetDialog;